<template>
    <b-modal
        id="paper-power-point-versions-modal"
        ref="paper-power-point-versions-modal"
        :title="$t('paper.versions')"
        :ok-title="$t('common.close')"
        :ok-only="true"
        size="xl"
        modal-class="apprentice-default-modal">
        <design-2021-apprentice-data-table
            :fields="fields"
            :items="powerPointVersionsIn"
            :sort-compare="sortCompare"
            nosearch>
            <template v-slot:cell(actions)="row">
                <div class="actions">
                    <b-button
                        class="btn-download btn-download-paper-version"
                        variant="primary-icon-only"
                        @click="powerpointDownload(id, row.item.version)"
                        target="_blank">
                    </b-button>
                </div>
            </template>
        </design-2021-apprentice-data-table>
    </b-modal>
</template>
<script>
export default {
    name: 'design-2021-paper-powerpoint-versions-modal-component',
    props: ['id', 'powerPointVersionsIn'],
    data() {
        return {
            fields: [
                {
                    key: 'version',
                    label: this.$t('paper.version'),
                    sortable: true,
                },
                {
                    key: 'created_at',
                    label: this.$t('paper.date'),
                    sortable: true,
                },
                {
                    key: 'actions',
                    label: this.$t('common.actions'),
                },
            ],
            groupTableColumns: ['version', 'date', 'actions'],
            groupTableOptions: {
                headings: {
                    version: this.$t('paper.version'),
                    date: this.$t('paper.version'),
                    actions: this.$t('common.actions'),
                },
                sortable: ['version', 'date'],
                filterable: ['version', 'date'],
            },
        };
    },
    methods: {
        powerpointDownload(id, version) {
            return (window.location.href = this.routes.paperPowerpointVersionDownload(id, version));
        },

        getUrl(version) {
            return $;
        },

        sortCompare: function sortCompare(firstRow, secondRow, key) {
            if (key === 'created_at' && firstRow[key] && secondRow[key]) {
                var firstDate = moment(firstRow[key]).format('YYYY-MM-DD HH:mm:ss');
                var secondDate = moment(secondRow[key]).format('YYYY-MM-DD HH:mm:ss');
                return firstDate < secondDate ? -1 : firstDate > secondDate ? 1 : 0;
            } else {
                return false;
            }
        },
    },
};
</script>

<style scoped lang="scss"></style>
